module.exports = __webpack_public_path__ + "static/media/mdwa.e76431cd.ttf";